import { helper } from '@ember/component/helper';

export default helper(function documentQuerySelector(positional /*, named*/) {
  return document.querySelector(positional) ?? null;
});
